var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOlbyLines = function SvgOlbyLines(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 313,
    viewBox: "0 0 352 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M344.297 0.429688L256.289 397.069",
    stroke: "#00594D",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M312.262 0.429688L224.254 397.069",
    stroke: "#00594D",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280.226 0.429688L192.211 397.069",
    stroke: "#00594D",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M248.184 0.429688L160.176 397.069",
    stroke: "#00594D",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M216.149 0.429688L128.141 397.069",
    stroke: "#00594D",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.117 0.429688L96.1094 397.069",
    stroke: "#00594D",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.078 0.429688L64.0703 397.069",
    stroke: "#00594D",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.039 0.429688L32.0312 397.069",
    stroke: "#00594D",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.008 0.429688L0 397.069",
    stroke: "#00594D",
    strokeWidth: 3.52,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M319.873 143.369H305.496L337.305 0H351.682L319.873 143.369Z",
    fill: "#00594D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M287.834 143.369H273.457L305.273 0H319.65L287.834 143.369Z",
    fill: "#00594D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M255.799 143.369H241.422L273.23 0H287.607L255.799 143.369Z",
    fill: "#00594D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M223.764 143.369H209.387L241.195 0H255.572L223.764 143.369Z",
    fill: "#00594D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M191.721 143.369H177.344L209.16 0H223.537L191.721 143.369Z",
    fill: "#00594D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M159.69 143.369H145.312L177.128 0H191.505L159.69 143.369Z",
    fill: "#00594D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.654 143.369H113.277L145.086 0H159.463L127.654 143.369Z",
    fill: "#00594D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6193 143.369H81.2422L113.051 0H127.428L95.6193 143.369Z",
    fill: "#00594D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5802 143.369H49.2031L81.0189 0H95.396L63.5802 143.369Z",
    fill: "#00594D"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOlbyLines);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";